import * as Styled from "../CreateEventPage.styles";

import { Typography, useTheme } from "@mui/material";

const EventFeedbackSection = () => {
  const theme = useTheme();

  return (
    <Styled.FormSectionContainer>
      <Typography variant="h3">Event Feedback</Typography>
      <Typography
        variant="body2"
        style={{
          color: theme.colors.neutral.darkGray,
          marginTop: theme.spacing(1),
        }}
      >
        Attendees will automatically be prompted to complete a standardized event
        feedback form at the conclusion of your event. You will find results when
        you “View Completed Event” after your event concluded.
      </Typography>
    </Styled.FormSectionContainer>
  );
};

export default EventFeedbackSection;
